export function ImageLoader() {
  return (
    <svg
      width="351"
      height="351"
      viewBox="0 0 351 351"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.847656"
        y="0.0107422"
        width="350"
        height="350"
        fill="#E2E8ED"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M125.681 113.511C119.422 113.511 114.348 118.585 114.348 124.844V225.177C114.348 231.038 118.795 235.859 124.499 236.45L202.393 158.556C203.565 157.385 205.464 157.385 206.636 158.556L237.348 189.268V124.844C237.348 118.585 232.274 113.511 226.014 113.511H125.681ZM243.348 124.844C243.348 115.271 235.587 107.511 226.014 107.511H125.681C116.108 107.511 108.348 115.271 108.348 124.844V225.177C108.348 234.75 116.108 242.511 125.681 242.511H226.014C235.587 242.511 243.348 234.75 243.348 225.177V124.844ZM237.348 197.753L204.514 164.92L132.924 236.511H226.014C232.274 236.511 237.348 231.437 237.348 225.177V197.753ZM150.764 142.177C146.484 142.177 143.014 145.647 143.014 149.927C143.014 154.208 146.484 157.677 150.764 157.677C155.045 157.677 158.514 154.208 158.514 149.927C158.514 145.647 155.045 142.177 150.764 142.177ZM137.014 149.927C137.014 142.333 143.17 136.177 150.764 136.177C158.358 136.177 164.514 142.333 164.514 149.927C164.514 157.521 158.358 163.677 150.764 163.677C143.17 163.677 137.014 157.521 137.014 149.927Z"
        fill="#C2D0DC"
      />
    </svg>
  );
}
